import type { TestProviderPartialProps } from '@wix/yoshi-flow-bm/testkit';
import { exportServiceMocks, appSettingsMocks } from '@wix/bex-core/testkit';
import { whenRequest } from '@wix/yoshi-flow-bm/testkit/http-client/client';
import { dataExtensionServiceMocks } from '../test-utils';

/**
 * @deprecated
 * use `wixPatternsTestProviderPropsOverrides`
 */
export function cairoTestProviderPropsOverrides(
  overrides?: TestProviderPartialProps,
): TestProviderPartialProps {
  return {
    ...overrides,
    mocks: [
      ...(overrides?.mocks ?? []),
      ...exportServiceMocks(whenRequest).mocks,
      ...appSettingsMocks(whenRequest),
      ...dataExtensionServiceMocks(whenRequest).mocks,
    ],
  };
}

export const wixPatternsTestProviderPropsOverrides =
  cairoTestProviderPropsOverrides;
